import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=079e3703&scoped=true"
import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=079e3703&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e3703",
  null
  
)

export default component.exports